module.exports = __webpack_public_path__ + "img/hand-key.24231c31.svg";